import { useAuth } from "../../lib/auth";

const settings = [
  [
    "SEO",
    "Titles, descriptions, canonical, Open Graph, sitemap, robots y redirects viven en la web publica y docs/seo.md.",
  ],
  [
    "Seguridad",
    "Auth, RBAC, RLS, HMAC de webhooks y restricciones de escritura estan documentados en docs/seguridad.md.",
  ],
  [
    "Integracion SaaS",
    "La sincronizacion usa webhook firmado y reconciliacion. El SaaS no se consulta por cada visitante.",
  ],
  ["Deployment", "Flujo esperado: development -> staging -> production con lint, typecheck y build."],
];

export function SettingsPage() {
  const { profile } = useAuth();

  return (
    <div>
      <h1 className="font-display text-ink text-2xl font-bold">Configuracion</h1>
      <p className="text-mist mt-1 text-sm">Resumen operativo de la primera version de produccion.</p>

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {settings.map(([title, description]) => (
          <article key={title} className="border-sand/40 bg-paper shadow-card rounded-lg border p-5">
            <h2 className="font-display text-ink text-xl font-bold">{title}</h2>
            <p className="text-ink/70 mt-2 text-sm leading-relaxed">{description}</p>
          </article>
        ))}
      </div>

      <section className="border-sand/40 bg-paper mt-6 rounded-lg border p-5">
        <h2 className="font-display text-ink text-xl font-bold">Usuario actual</h2>
        <dl className="mt-4 grid gap-3 text-sm sm:grid-cols-3">
          <div>
            <dt className="text-mist">Nombre</dt>
            <dd className="text-ink font-medium">{profile?.full_name ?? "Sin nombre"}</dd>
          </div>
          <div>
            <dt className="text-mist">Rol</dt>
            <dd className="text-ink font-medium">{profile?.role ?? "Sin rol"}</dd>
          </div>
          <div>
            <dt className="text-mist">Permisos</dt>
            <dd className="text-ink font-medium">RBAC + RLS</dd>
          </div>
        </dl>
      </section>
    </div>
  );
}
